"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationRole = void 0;
var OrganizationRole;
(function (OrganizationRole) {
    OrganizationRole["OWNER"] = "owner";
    OrganizationRole["ADMIN"] = "admin";
    OrganizationRole["MANAGER"] = "manager";
    OrganizationRole["MEMBER"] = "member";
    OrganizationRole["VIEWER"] = "viewer";
})(OrganizationRole || (exports.OrganizationRole = OrganizationRole = {}));
